<template>
  <div
    class="goal-lock-btn"
    v-on="$listeners">
    <span
      class="material-icons goal-lock-btn__icon"
      :class="{'goal-lock-btn__icon--locked': locked}">
      lock
    </span>
  </div>
</template>

<script>
export default {
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  }

}
</script>

<style lang="scss" scoped>
.goal-lock-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  padding: 3px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &__icon {
    color: $grey11;
    &--locked {
      color: $black;
    }
  }
}
</style>